/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ zalo_error: NonNullable<unknown> }} Error_Zalo_Oauth_Exchange_FailedInputs */

const vi_error_zalo_oauth_exchange_failed = /** @type {(inputs: Error_Zalo_Oauth_Exchange_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Zalo từ chối mã cấp quyền (mã lỗi ${i?.zalo_error}): mã quá 10 phút, đã dùng, hoặc App/OA không khớp. Bấm Kết nối lại.`)
};

/**

* @param {Error_Zalo_Oauth_Exchange_FailedInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const error_zalo_oauth_exchange_failed = /** @type {((inputs: Error_Zalo_Oauth_Exchange_FailedInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Zalo_Oauth_Exchange_FailedInputs, { locale?: "vi" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_error_zalo_oauth_exchange_failed(inputs)
});